export const plans = [
  // Multi-tenant
  {
    id: 'multi-s',
    signupPlanId: 'multi-s',
    backendPlanId: 'plan_s',
    type: 'マルチテナント',
    title: 'プランS',
    titleEn: 'Plan S',
    priceAnnual: '5,000円',
    priceMonthly: '6,000円',
    creditsGranted: '250',
    creditsLimit: '500',
    features: ['小規模向けの基本プラン'],
    featuresEn: ['Essential plan for small teams']
  },
  {
    id: 'multi-m',
    signupPlanId: 'multi-m',
    backendPlanId: 'plan_m',
    type: 'マルチテナント',
    title: 'プランM',
    titleEn: 'Plan M',
    priceAnnual: '21,000円',
    priceMonthly: '24,000円',
    creditsGranted: '1,200',
    creditsLimit: '2,400',
    features: ['成長中のチーム向け'],
    featuresEn: ['Designed for growing teams']
  },
  {
    id: 'multi-l',
    signupPlanId: 'multi-l',
    backendPlanId: 'plan_l',
    type: 'マルチテナント',
    title: 'プランL',
    titleEn: 'Plan L',
    priceAnnual: '42,000円',
    priceMonthly: '50,000円',
    creditsGranted: '2,500',
    creditsLimit: '5,000',
    features: ['エンタープライズでの本格利用'],
    featuresEn: ['Enterprise plan for large-scale usage']
  }
];
